import Pdf from '../assets/pdf.png';
import Excel from '../assets/ms-excel.png';
import Word from '../assets/ms-word.png';
import Ppt from '../assets/ms-powerpoint.png';
import Zip from '../assets/ms-zip.png';

const previewSelector = uploadedFile => {
  const fileType = uploadedFile.fileType;
  if (fileType) {
    if (fileType.indexOf("image") > -1) {
      return uploadedFile.url;
    } else if (fileType.indexOf("word") > -1) {
      return Word;
    } else if (
      fileType.indexOf("excel") > -1 ||
      fileType.indexOf("spreadsheetml") > -1
    ) {
      return Excel;
    } else if (fileType.indexOf("powerpoint") > -1) {
      return Ppt;
    } else if (fileType.indexOf("pdf") > -1) {
      return Pdf;
    } else if (fileType.indexOf("zip") > -1) {
      return Zip;
    }
  }
};

export default previewSelector;
